/**
 * Dev-only logging. Raw `console.*` is banned everywhere else in this codebase
 * (Biome enforces it) — import these instead. In production builds every call
 * is a no-op, so nothing leaks to a customer's console.
 */
const isDev = import.meta.env.DEV

type LogArgs = readonly unknown[]

export function devLog(...args: LogArgs): void {
  if (!isDev) return
  console.log(...args)
}

export function devWarn(...args: LogArgs): void {
  if (!isDev) return
  console.warn(...args)
}

export function devError(...args: LogArgs): void {
  if (!isDev) return
  console.error(...args)
}
